module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-3ebf24e16aef170398c5a5d678ad6968.png";